module.exports = {
  "userView": {
    "name": "user view",
    "class": "view",
    "properties": {
      "userId": "number",
      "viewedUserId": "number"
    },
    "namespace": "growth-hub"
  },
  "userEdit": {
    "name": "user edit",
    "class": "interaction",
    "properties": {
      "userId": "number"
    },
    "namespace": "growth-hub"
  },
  "usersSearch": {
    "name": "users search",
    "class": "interaction",
    "properties": {
      "userId": "number",
      "term": "string",
      "total": "number"
    },
    "namespace": "growth-hub"
  },
  "userFollow": {
    "name": "user follow",
    "class": "interaction",
    "properties": {
      "userId": "number",
      "followedUserId": "number"
    },
    "namespace": "growth-hub"
  },
  "userUnfollow": {
    "name": "user unfollow",
    "class": "interaction",
    "properties": {
      "userId": "number",
      "followedUserId": "number"
    },
    "namespace": "growth-hub"
  }
};


//////////////////
// WEBPACK FOOTER
// ./events.yaml
// module id = 614
// module chunks = 171